export default {
  element1: {
    title: 'Wochentag',
    text:
      'Wochentag in einem kleinen Fenster unter der Ziffer Zwölf. Altdeutscher Name, Donstag für Donnerstag.'
  },
  element2: {
    title: 'Moderne Stunde (ca. 12.30 Uhr)',
    text:
      'Angezeigt durch die goldene Hand am Sonnenzeiger. Es handelt sich um die Lokalzeit von Bern, die der Mitteleuropäischen Zeit um eine halbe Stunde nachgeht.'
  },
  element3: {
    title: 'Sonne',
    text:
      'Die Sonne steht im Tierkreiszeichen Fische. Die Sonne durchläuft in einem Jahr alle zwölf Zeichen.'
  },
  element4: {
    title: 'Temporalstunde',
    text:
      'Der Zeiger zeigt die Temporalstunde 10. Die Zeit des Tageslichts ist in zwölf Stunden unterteilt. Da die Tage unterschiedlich lang sind, dauern die temporalen Stunden im Sommer länger und im Winter kürzer als eine Stunde.'
  },
  element5: {
    title: 'Horizont',
    text: 'Temporalstunde 12. Die Sonne geht unter.'
  },
  element6: {
    title: 'Dämmerungsgrenze',
    text:
      '. Von nun an herrscht tiefe Nacht. Die astronomische Dämmerung ist erreicht, wenn die Sonne 18 Grad unter dem Horizont steht.'
  },
  element7: {
    title: 'Das Datum',
    text:
      'Hier der «19. Merz», wird durch einen Stern, der der Sonne gegenübersteht, angezeigt. Die Schilder tragen die alten Namen. Beispiele: Brachmonat ist Juni, Heumonat ist Juli.'
  },
  element8: {
    title: 'Der Mond',
    text: 'Steht im Tierkreiszeichen Waage.'
  },
  element9: {
    title: 'Die Mondphase',
    text:
      'Die Mondphase  wird mit einer drehbaren schwarzgoldenen Kugel angezeigt. Der Mond ist abnehmend.'
  }
}



// WEBPACK FOOTER //
// ./src/components/main/texts.js